import React, { useEffect, useState } from 'react';
import { post } from 'store/request';
import { Select } from '@tencent/spaui';

let IndustryList: any[] = [];

// eslint-disable-next-line react/display-name
export default (props: { value: any[]; onChange: (data: any[]) => void }) => {
  const [list, setList] = useState<any[]>(IndustryList);
  const [value, setValue] = useState(props.value);
  useEffect(() => {
    if (IndustryList.length !== 0) {
      return;
    }
    post('/meta/industry', {
      level: 1,
    }).then((res) => {
      const formatList = res.map((item: { display_name: string; industry_id: number }) => ({
        label: item.display_name,
        value: item.industry_id,
      }));
      setList(formatList);
      IndustryList = formatList;
    });
  }, []);
  return (
    <Select
      multiple
      search
      style={{ width: '100%' }}
      data={list}
      value={value}
      onChange={(e: EventTarget, value: any[]) => {
        setValue(value);
        props.onChange?.(value);
      }}
    />
  );
};
